export const getDeviceType = (state) => state.deviceVersion.isKarieDUO
